import React, { useEffect, useRef, useState } from "react";
import "./Datalibrary.css";
import searchbtn from "../../../Assets/images/search.svg";
import deleteimg from "../../../Assets/images/delete-img.png";
import { useNavigate } from "react-router-dom";
import Pagination from "../../Pagination/Pagination";
import { useDispatch } from "react-redux";
import {
  showLoader,
  hideLoader,
} from "../../../Redux/Slice/Loader/loaderSlice";
import DataLibraryManagement from "../../../Services/DataLibraryService/DataLibraryService";
import { HandleApiError } from "../../../Utils/CommonErrors/HandleApiError";
import showToast from "../../../Utils/Toast/ToastNotification";
import { Modal } from "bootstrap";
import { useSelector } from "react-redux";

const Datalibrary = () => {
  const dateInputRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const createdFromDateRef = useRef(null);
  const createdToDateRef = useRef(null);
  const updatedFromDateRef = useRef(null);
  const updatedToDateRef = useRef(null);

  const [selectedId, setSelectedId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [sortBy, setSortBy] = useState("name");
  const [sortOrder, setSortOrder] = useState("ASC");
  const [isFilterCleared, setIsFilterCleared] = useState(false);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filters, setFilters] = useState({
    created_from: "",
    created_to: "",
    updated_from: "",
    updated_to: "",
    page: 1,
    limit: 10,
  });
  const user_id = useSelector(
    (state) => state.auth?.user?.data?.body?.data?.userData?.id
  );

  const token = useSelector(
    (state) => state.auth?.user?.data?.body?.data?.token
  );

  const handleFocus = (ref) => {
    if (ref.current) {
      ref.current.showPicker?.(); // Open date picker if supported
    }
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(e.target.value);
    setPage(0);
  };

  const getDataLibrary = async () => {
    dispatch(showLoader());
    const params = {
      search: searchQuery || "",
      page: page + 1,
      limit: rowsPerPage,
      sort_by: `"${sortBy}"`,
      sort_order: sortOrder,
      created_from: filters.created_from,
      created_to: filters.created_to,
      updated_from: filters.updated_from,
      updated_to: filters.updated_to,
    };
    try {
      const response = await DataLibraryManagement.getDataLibrary(params, token);
      if (response?.data?.statusCode == 200) {
        setData(response?.data?.body?.data?.dataLibrary);
        setTotalRecords(response?.data?.body?.data?.pagination?.totalItems);
      } else {
        showToast("error", response.data.body?.message);
      }
    } catch (error) {
      await HandleApiError(error);
    } finally {
      dispatch(hideLoader());
    }
  };
  useEffect(() => {
    getDataLibrary();
  }, [debouncedSearch, page, rowsPerPage, sortBy, sortOrder]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchQuery]);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setPage(0);
  };

  useEffect(() => {
    if (isFilterCleared) {
      getDataLibrary();
      setIsFilterCleared(false);
    }
  }, [isFilterCleared]);

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "ASC" ? "DESC" : "ASC");
    } else {
      setSortBy(column);
      setSortOrder("ASC");
    }
  };

  const handleFilterChange = (e) => {
    const { id, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [id]: value,
    }));
  };
  const handleFilterSubmit = (e) => {
    e.preventDefault();
    getDataLibrary();
  };

  const handleClearFilter = (e) => {
    e.preventDefault();

    setFilters({
      created_from: "",
      created_to: "",
      updated_from: "",
      updated_to: "",
      page: page + 1,
      limit: rowsPerPage,
    });
    setIsFilterCleared(true);
    setSearchQuery("");
    if (createdFromDateRef.current) createdFromDateRef.current.value = "";
    if (createdToDateRef.current) createdToDateRef.current.value = "";
    if (updatedFromDateRef.current) updatedFromDateRef.current.value = "";
    if (updatedToDateRef.current) updatedToDateRef.current.value = "";
    // getDataLibrary();
  };
  const modalRef = useRef(null);

  const openModal = () => {
    if (modalRef.current) {
      const modalInstance = new Modal(modalRef.current, { backdrop: "static" });

      const oldInstance = Modal.getInstance(modalRef.current);
      if (oldInstance) {
        oldInstance.dispose();
      }
      const newInstance = new Modal(modalRef.current, { backdrop: "static" });
      newInstance.show();
    }
  };

  const handleDelete = async () => {
    try {
      const params = {
        dataLibraryId: selectedId,
        deleted_by: user_id,
      };
      await DataLibraryManagement.deleteLibrary(params, token);
      showToast("success", "Data Library deleted successfully");
      await getDataLibrary();
    } catch (error) {
      await HandleApiError(error);
    }
  };

  const [copiedId, setCopiedId] = useState(null);

  const copyUrl = async (dataLibraryId) => {
    const currentUrl = window.location.href;

    let apiUrl = '';

    if (currentUrl.includes('lively-sky-0ff2e5d0f.6.azurestaticapps.net')) {
      apiUrl = `https://apim-propertyinspection-dev.azure-api.net/getDataLibraryForTemplate?id=${dataLibraryId}`;
    } else if (currentUrl.includes('icy-smoke-0ef3d8b0f.6.azurestaticapps.net')) {
      apiUrl = `https://propertyinspection-uat-apim.azure-api.net/getDataLibraryForTemplate?id=${dataLibraryId}`;
    } else if (currentUrl.includes('http://localhost:3000/')) {
      apiUrl = `http://localhost:7071/api/getDataLibraryForTemplate?id=${dataLibraryId}`;
    } else if (currentUrl.includes('https://www.siteinspect.sdss.net.au')) {
      apiUrl = `https://apim-propertyinspection-prod.azure-api.net/getDataLibraryForTemplate?id=${dataLibraryId}`;
    } else {
      alert('Unknown environment');
      return;
    }

    try {
      await navigator.clipboard.writeText(apiUrl);
      setCopiedId(dataLibraryId);

      // Reset after 2 seconds
      setTimeout(() => {
        setCopiedId(null);
      }, 2000);
    } catch (err) {
      await showToast("error", "Failed to copy!");
    }
  };

  return (
    <>
      <div className="main-inner-block">
        <div className="content">
          <div className="d-flex align-items-center justify-content-between mb-4 block-one gap-3">
            <div className="heading-content ms-0 mt-0">Data Library</div>
            <div className="heading-content mt-0">
              <button
                className="green-btn green-signin addnewuser"
                onClick={() => navigate("/add-datalibrary")}
              >
                + Add Data Library
              </button>
            </div>
          </div>
          <div className="white-box bg-box-mob">
            <div className="inner-content-block">
              <div className="listing-title-block d-flex justify-content-between">
                <div className="box-listing-title">
                  Data Library Details
                  <span className="d-block">
                    Showing a list of Data Library detail.
                  </span>
                </div>
                <div className="searchbar-btn d-flex align-items-center gap-4">
                  <div className="input-search-box position-relative">
                    <input
                      type="text"
                      id="name"
                      placeholder="Search"
                      value={searchQuery}
                      onChange={handleSearch}
                    />
                    <div className="searchbtn">
                      <img src={searchbtn} alt="searchbtn"></img>
                    </div>
                    {searchQuery && (
                      <button
                        className="clear-btn"
                        onClick={() => setSearchQuery("")}
                      >
                        ✖
                      </button>
                    )}
                  </div>
                  <div className="filter d-flex align-items-center gap-4">
                    <a
                      className="filter-inner"
                      href="#"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      onClick={(e) => {
                        e.preventDefault();
                        openModal();
                      }}
                    >
                      <span className="me-2">
                        <svg
                          width="20"
                          height="21"
                          viewBox="0 0 20 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5 10.332H15M2.5 5.33203H17.5M7.5 15.332H12.5"
                            stroke="#475467"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                      Filter
                    </a>
                    <div
                      class="modal fade"
                      id="exampleModal"
                      tabindex="-1"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                          <div className="text-end">
                            <button
                              type="button"
                              class="btn-close "
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>

                          <div>
                            <h1
                              class="modal-title fs-5 text-center filter-title"
                              id="exampleModalLabel"
                            >
                              Data Library Filter
                            </h1>
                          </div>
                          <div class="modal-body">
                            <form
                              onSubmit={(e) => {
                                e.preventDefault();
                                getDataLibrary();
                              }}
                            >
                              <div class="mb-3">
                                <label
                                  htmlFor="created_from"
                                  className="form-label"
                                >
                                  Date Created
                                </label>

                                <div className="d-flex gap-2">
                                  <input
                                    type="date"
                                    className="form-control"
                                    id="created_from"
                                    name="created_from"
                                    ref={createdFromDateRef}
                                    onChange={handleFilterChange}
                                    onClick={() =>
                                      handleFocus(createdFromDateRef)
                                    }
                                    placeholder="From"
                                  />{" "}
                                  <span>-</span>
                                  <input
                                    type="date"
                                    className="form-control"
                                    id="created_to"
                                    name="created_to"
                                    ref={createdToDateRef}
                                    onChange={handleFilterChange}
                                    onClick={() =>
                                      handleFocus(createdToDateRef)
                                    }
                                    placeholder="To"
                                  />
                                </div>
                              </div>

                              <div class="mb-3">
                                <label className="form-label">
                                  Last Updated
                                </label>
                                <div className="d-flex gap-2">
                                  <input
                                    type="date"
                                    className="form-control"
                                    id="updated_from"
                                    name="updated_from"
                                    onChange={handleFilterChange}
                                    ref={updatedFromDateRef}
                                    onClick={() =>
                                      handleFocus(updatedFromDateRef)
                                    }
                                    placeholder="From"
                                  />{" "}
                                  <span>-</span>
                                  <input
                                    type="date"
                                    className="form-control"
                                    id="updated_to"
                                    name="updated_to"
                                    ref={updatedToDateRef}
                                    onChange={handleFilterChange}
                                    onClick={() =>
                                      handleFocus(updatedToDateRef)
                                    }
                                    placeholder="To"
                                  />
                                </div>
                              </div>

                              <div className="text-center">
                                <button
                                  type="submit"
                                  class="green-btn updt-button"
                                  data-bs-dismiss="modal"
                                  onClick={(e) => handleFilterSubmit(e)}
                                >
                                  Filter
                                </button>
                                <button
                                  type="button"
                                  class="green-btn updt-button ms-2"
                                  data-bs-dismiss="modal"
                                  onClick={handleClearFilter}
                                >
                                  Clear Filter
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-block">
                <table class="table">
                  <thead class="table-headers">
                    <tr>
                      <th onClick={() => handleSort("name")}>
                        Name
                        <span className="ms-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            width="10"
                            height="17"
                            viewBox="0 0 32 32"
                          >
                            <g>
                              <path
                                d="M7 13h18a1 1 0 0 0 .707-1.707l-9-9a1 1 0 0 0-1.414 0l-9 9A1 1 0 0 0 7 13zM25 19H7a1 1 0 0 0-.707 1.707l9 9a1 1 0 0 0 1.414 0l9-9A1 1 0 0 0 25 19z"
                                fill="#949494"
                                opacity="1"
                              />
                            </g>
                          </svg>
                        </span>
                      </th>
                      <th>Description</th>

                      <th onClick={() => handleSort("created_at")}>
                        Date Created
                        <span className="ms-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            width="10"
                            height="17"
                            viewBox="0 0 32 32"
                          >
                            <g>
                              <path
                                d="M7 13h18a1 1 0 0 0 .707-1.707l-9-9a1 1 0 0 0-1.414 0l-9 9A1 1 0 0 0 7 13zM25 19H7a1 1 0 0 0-.707 1.707l9 9a1 1 0 0 0 1.414 0l9-9A1 1 0 0 0 25 19z"
                                fill="#949494"
                                opacity="1"
                              />
                            </g>
                          </svg>
                        </span>
                      </th>
                      <th onClick={() => handleSort("updated_at")}>
                        Last Updated
                        <span className="ms-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            width="10"
                            height="17"
                            viewBox="0 0 32 32"
                          >
                            <g>
                              <path
                                d="M7 13h18a1 1 0 0 0 .707-1.707l-9-9a1 1 0 0 0-1.414 0l-9 9A1 1 0 0 0 7 13zM25 19H7a1 1 0 0 0-.707 1.707l9 9a1 1 0 0 0 1.414 0l9-9A1 1 0 0 0 25 19z"
                                fill="#949494"
                                opacity="1"
                              />
                            </g>
                          </svg>
                        </span>
                      </th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length > 0 ? (
                      data.map((data, index) => (
                        <tr key={data.id}>
                          <td>
                            <a className="name-email-text"
                              onClick={() => navigate(`/update-datalibrary/${data.id}`)}
                            >
                              {data.name}
                            </a>
                          </td>
                          <td
                            style={{
                              textAlign: data.description ? "left" : "center",
                            }}
                          >
                            <div
                              className="text-truncate"
                              style={{ width: '200px' }}
                            >
                              {data.description ? data.description : "-"}
                            </div>
                          </td>
                          <td
                            style={{
                              textAlign: !data.created_at ? "center" : "left",
                            }}
                          >
                            {data.created_at
                              ? new Date(data.created_at).toLocaleDateString()
                              : "-"}
                          </td>
                          <td
                            style={{
                              textAlign: data.updated_at ? "left" : "center",
                            }}
                          >
                            {data.updated_at
                              ? new Date(data.updated_at).toLocaleDateString()
                              : "-"}
                          </td>
                          <td>
                            <div className="d-flex gap-3">
                              <a
                                className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                                onClick={() =>
                                  navigate(`/update-datalibrary/${data.id}`)
                                }
                              >
                                <i className="fas fa-pencil-alt me-2"></i>
                                <span className="tooltip-text">Update</span>
                              </a>
                              <a
                                className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                                onClick={() => copyUrl(data.id)}
                                style={{ cursor: 'pointer' }}
                              >
                                {copiedId === data.id ? (
                                  <i className="fa-solid fa-check text-success"></i> // ✅ icon
                                ) : (
                                  <i className="fa-solid fa-clone"></i> // 📋 icon
                                )}
                                <span className="tooltip-text">
                                  {copiedId === data.id ? 'Copied!' : 'Copy URL'}
                                </span>
                              </a>
                              <a
                                className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                                href="#"
                                data-bs-toggle="modal"
                                data-bs-target="#deletemodal"
                                onClick={() => setSelectedId(data.id)}
                              >
                                <i className="fas fa-trash me-2"></i>
                                <span className="tooltip-text">Delete</span>
                              </a>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">
                          No Data library found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>


              {/* responsive */}
              <div className="mobile-user-list d-block d-md-none">
                {data.length > 0 ? (
                  data.map((data, index) => (
                    <div key={data.id} className="col-md-6 col-lg-4 mb-4">
                      <div className="card shadow-sm h-100">
                        <div className="card-body">

                          <p className="mb-1">
                            <strong>Name:</strong>{" "}
                            {data.name}
                          </p>

                          <p className="mb-1">
                            <strong>Description:</strong>{" "}
                            {data.description ? data.description : "-"}
                          </p>

                          <p className="mb-1">
                            <strong>Date Created:</strong>{" "}
                            {data.created_at
                              ? new Date(data.created_at).toLocaleDateString()
                              : "-"}
                          </p>


                          <p className="mb-1">
                            <strong>Last Updated:</strong>{" "}
                            {data.updated_at
                              ? new Date(data.updated_at).toLocaleDateString()
                              : "-"}
                          </p>


                          <div className="d-flex justify-content-end mt-3 gap-3">
                            <a
                              className="text-decoration-none fonticon"
                              onClick={() =>
                                navigate(`/update-datalibrary/${data.id}`)
                              }
                            >
                              <i className="fas fa-pencil-alt me-2"></i>
                            </a>
                            <a
                              className="d-flex align-items-center text-decoration-none fonticon"
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#deletemodal"
                              onClick={() => setSelectedId(data.id)}
                            >
                              <i className="fas fa-trash me-2"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="col-12 text-center">
                    <div className="alert alert-info">No Data Library found</div>
                  </div>
                )}
              </div>

              <div className="pagination-block">
                {
                  <Pagination
                    count={totalRecords}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onRowsPerPageChange={handleRowsPerPageChange}
                  />
                }
              </div>
            </div>
          </div>

          <div
            class="modal fade"
            id="deletemodal"
            tabindex="-1"
            aria-labelledby="deletemodalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered delete-modal">
              <div class="modal-content">
                <div class="modal-body">
                  <div className="text-center delete-img-blk">
                    <img src={deleteimg} alt="delete-img"></img>
                  </div>
                  <div className="ques-title text-center">
                    Are you sure ?
                    <p className="m-0">
                      Are you sure you really want to delete this record? This
                      process cannot be undone.
                    </p>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-center gap-3 btn-block">
                  <button
                    type="button"
                    class="gray-outline-btn"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="orange-btn"
                    data-bs-dismiss="modal"
                    onClick={handleDelete}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Datalibrary;
